import { render } from "./SidebarPage.vue?vue&type=template&id=e1366cc2"
import script from "./SidebarPage.vue?vue&type=script&lang=js"
export * from "./SidebarPage.vue?vue&type=script&lang=js"

import "./SidebarPage.vue?vue&type=style&index=0&id=e1366cc2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__